<template>
<div class="centered" id="live_shows">
    <h1>הוספת הופעה</h1>

    <div class="inner_wrapper">

    <div class="gallery_wrapper">
        <label>תמונה</label>
        <Gallery :max="1" v-model="form.pic"></Gallery>
    </div>
    
    <div class="form_wrapper">

        <div>
            <md-input v-model="form.artist_name" label="שם האמן"></md-input>
        </div>
        
        <div>
            <md-input v-model="form.location" label="מקום האירוע"></md-input>
        </div>
        
        <div>
            <md-input type="date" v-model="form.date" label="תאריך"></md-input>
        </div>
        
        <div>
            <md-input v-model="form.time" label="שעה"></md-input>
        </div>
        
        <div>
            <md-input v-model="form.buy_link" label="לינק לרכישת כרטיסים"></md-input>
        </div>

        <div >
            <md-input type="textarea" v-model="form.text" label="תיאור קצר"></md-input>
        </div>
        <div>
            <a class="btn" @click="save">שמירה</a>
        </div>
    </div>
    </div>


</div>
</template>
    
<script>
import Gallery from '@/components/gallery.vue';
export default {
  components: { Gallery },
    data(){
    return {
        form: {
            artist_name: this.get_me().artists[0].f_name,
            location: '',
            date: new Date(),
            time: '',
            buy_link: '',
            text: '',
            pic: 0
        },
        loaded: false
    }
    },
    methods:{
        save(){
            this.api({ action: 'user_shows_save', data: {...this.form, pic: this.form.pic[0]?.id} }, () => { 
                //this.user_data = data.data
                this.alert('הפרטים נשמרו בהצלחה');
                this.$router.push('/edit_shows');
            } );
        }

    }
    
    
}
</script>
<style  lang="scss" scooped>
.inner_wrapper{display: flex;padding: 20px;justify-content: center;gap: 30px;
    @media (max-width: 600px) {flex-direction: column;}
    @media (min-width: 600px) {}

    .form_wrapper { display: grid;   grid-template-columns: repeat(2, 1fr); gap:30px;
        
    }
    .gallery_wrapper{flex-basis: 40%;max-width: 300px;
        @media (max-width: 600px) {max-width: 200px;}
        @media (min-width: 600px) {}
    }
}

</style>